// Suggested variable names for OpenDock location configs. Surfaced as
// autocomplete suggestions on the variable Name field — users can still type
// any name; these just steer toward the known, commonly-used ones.
export const VAR_NAME_SUGGESTIONS = [
  "ccmail",
  "appointmentNotes",
]
